import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogHeader, DialogHeading } from '../../../Episode.Styled';
import FormInputText from '../../../../common/Forms/FormTextField';
import DropdownFormInput from '../../../../common/Forms/DropdownForm';
import FormInputMultiCheckbox from '../../../../common/Forms/FormCheckbox';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  setEpdIrId,
  setReportingProgram,
  setParoleAgentOfRecord,
  setIncidentLocation,
  setIncidentDate,
  setOrgAddress,
  setAdmitDate,
  setIncidentAddress,
  setIncidentTime,
  setCaseManagerName,
  setCaseManagerTelephone,
  setCaseManagerEmail,
  setDapo,
  setDhcs,
  setDrp,
  setOther,
  setOtherDescription,
  setIsContactedFire,
  setIsContactedParamedics,
  setIsContactedPolice,
  setContactedAgenciesName,
  setIsParoleArrested,
  setArrestingAgency,
  setArrestDate,
  setIsNewsMediaCoverage,
  setNewsAgency,
  setNewsRepNameAndPhone,
  setIsLawEnforcementContacted,
  setLawEnforcementAgency,
  setIncidentDescription,
  setIncidentCreateDate,
  setIncidentCreatedBy,
} from '../../../../../redux/episode/2284Tab/2284Form/2284Slice';
import {
  getFormSuccess,
  getSaveCancel,
} from '../../../../common/commonUtils/commonUtils';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import {
  EPISODE_2284_REPORTING_PROGRAM_ORG_ADDRESS_URL,
  EPISODE_2284_UPDATE_URL,
  formDateFormat,
  dateFormatWeek
} from '../../../../../constants';
import { getReportingProgram2284OrgAddress } from '../../../../../redux/episode/2284Tab/2284ReportingProgramOrgAddress/2284ReportingProgramOrgAddressSlice';
import { validation2284 } from '../2284Utils/2284Validation';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Pdf2284 from './Pdf2284';

const Dialog2284 = (props) => {
  const { open, setOpen, openBackdrop, authToken, fetchData } = props;

  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNew2284, setIsNew2284] = useState(false);
  const [open2284Dialog, setOpen2284Dialog] = useState(false);

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const form2284 = useSelector((state) => state.form2284);
  const {
    new2284Form,
    epdIrId,
    reportingProgram,
    reportingProgramId,
    paroleAgentOfRecord,
    incidentLocation,
    incidentDate,
    orgAddress,
    admitDate,
    incidentAddress,
    incidentTime,
    caseManagerName,
    caseManagerTelephone,
    caseManagerEmail,
    dapo,
    dhcs,
    drp,
    other,
    otherDescription,
    isContactedFire,
    isContactedParamedics,
    isContactedPolice,
    contactedAgenciesName,
    isParoleArrested,
    arrestingAgency,
    arrestDate,
    isNewsMediaCoverage,
    newsAgency,
    newsRepNameAndPhone,
    isLawEnforcementContacted,
    lawEnforcementAgency,
    incidentDescription,
    incidentCreateDate,
    incidentCreatedBy,
  } = form2284;

  const reportingProgramOrganizationAddress = useSelector(
    (state) => state.reportingProgramOrganizationAddress
  );

  const reference2284Data = useSelector((state) => state.reference2284Data);
  const { reportingPrograms, paroleAgentOfRecords } = reference2284Data;

  const defaultValue = {
    epdIrId: epdIrId,
    reportingProgram: reportingProgram ? reportingProgram : '',
    reportingProgramId: reportingProgramId,
    paroleAgentOfRecord: paroleAgentOfRecord ? paroleAgentOfRecord : '',
    incidentLocation: incidentLocation,
    incidentDate: moment(incidentDate).format(formDateFormat),
    orgAddress: reportingProgramOrganizationAddress,
    admitDate: moment(admitDate).format(formDateFormat),
    incidentAddress: incidentAddress,
    incidentTime: !incidentTime ? null : incidentTime.split('T')[1],
    caseManagerName: caseManagerName,
    caseManagerTelephone: caseManagerTelephone,
    caseManagerEmail: caseManagerEmail,
    dapo: dapo,
    dhcs: dhcs,
    drp: drp,
    other: other,
    otherDescription: otherDescription,
    isContactedFire: isContactedFire,
    isContactedParamedics: isContactedParamedics,
    isContactedPolice: isContactedPolice,
    contactedAgenciesName: contactedAgenciesName,
    isParoleArrested: isParoleArrested,
    arrestingAgency: arrestingAgency,
    arrestDate: moment(arrestDate).format(formDateFormat),
    isNewsMediaCoverage: isNewsMediaCoverage,
    newsAgency: newsAgency,
    newsRepNameAndPhone: newsRepNameAndPhone,
    isLawEnforcementContacted: isLawEnforcementContacted,
    lawEnforcementAgency: lawEnforcementAgency,
    incidentDescription: incidentDescription,
    incidentCreateDate: incidentCreateDate ? incidentCreateDate : '',
    incidentCreatedBy: incidentCreatedBy ? incidentCreatedBy : '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(validation2284),
  });
  const { handleSubmit, reset, control, register, formState } = useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.epdIrId,
    defaultValue.reportingProgramId,
    defaultValue.reportingProgram,
    defaultValue.paroleAgentOfRecord,
    defaultValue.incidentLocation,
    defaultValue.incidentDate,
    defaultValue.orgAddress,
    defaultValue.admitDate,
    defaultValue.incidentAddress,
    defaultValue.incidentTime,
    defaultValue.caseManagerName,
    defaultValue.caseManagerTelephone,
    defaultValue.caseManagerEmail,
    defaultValue.dapo,
    defaultValue.dhcs,
    defaultValue.drp,
    defaultValue.other,
    defaultValue.otherDescription,
    defaultValue.isContactedFire,
    defaultValue.isContactedParamedics,
    defaultValue.isContactedPolice,
    defaultValue.contactedAgenciesName,
    defaultValue.isParoleArrested,
    defaultValue.arrestingAgency,
    defaultValue.arrestDate,
    defaultValue.isNewsMediaCoverage,
    defaultValue.newsAgency,
    defaultValue.newsRepNameAndPhone,
    defaultValue.isLawEnforcementContacted,
    defaultValue.lawEnforcementAgency,
    defaultValue.incidentDescription,
    defaultValue.incidentCreateDate,
    defaultValue.incidentCreatedBy,
  ]);

  useEffect(() => {
    if (authToken) {
      if (reportingProgram) {
        fetchtReportingProgramOrganizationAddress();
      }
    }
  }, [authToken, reportingProgram]);

  const fetchtReportingProgramOrganizationAddress = async () => {
    const commonParams = `${EPISODE_2284_REPORTING_PROGRAM_ORG_ADDRESS_URL}/${reportingProgram}`;
    const authorization = authToken;
    dispatch(
      getReportingProgram2284OrgAddress({ commonParams, authorization })
    );
  };

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${EPISODE_2284_UPDATE_URL}`;
    const authorization = authToken;
    const tempIncidentDate = incidentDate ? incidentDate.split('T')[0] : null;
    
    console.log('################')

    console.log('### tempIncidentDate');
    console.log(tempIncidentDate);
    
    console.log('### incidentTime');
    console.log(!incidentTime ? null : incidentTime.includes('T') ? incidentTime.split('T')[1] : incidentTime);
    
    const incidentDateTime = !incidentTime ? null : (tempIncidentDate + 'T' + (!incidentTime ? '00:00:00' : incidentTime.includes('T') ? incidentTime.split('T')[1] : incidentTime));

    console.log('### incidentDateTime');
    console.log(incidentDateTime);

    const payload = {
      epdIrId: new2284Form ? 0 : epdIrId,
      incidentReportEpdId: episodeId,
      reportingProgramId: reportingProgram ? reportingProgram : null,
      paroleAgentOfRecord: paroleAgentOfRecord ? paroleAgentOfRecord : null,
      incidentLocation: incidentLocation,
      incidentDate:
        moment(incidentDate).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(incidentDate).format(formDateFormat),
      orgAddress: reportingProgramOrganizationAddress,
      admitDate:
        moment(admitDate).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(admitDate).format(formDateFormat),
      incidentAddress: incidentAddress,
      incidentTime: incidentDateTime,
      //incidentTime:
      //  moment(incidentDateTime).format(dateFormatWeek) === 'Invalid date'
      //    ? null
      //    : moment(incidentDateTime).format(dateFormatWeek),
      caseManagerName: caseManagerName,
      caseManagerTelephone: caseManagerTelephone,
      caseManagerEmail: caseManagerEmail,
      dapo: dapo,
      dhcs: dhcs,
      drp: drp,
      other: other,
      otherDescription: otherDescription,
      isContactedFire: isContactedFire,
      isContactedParamedics: isContactedParamedics,
      isContactedPolice: isContactedPolice,
      contactedAgenciesName: contactedAgenciesName,
      isParoleArrested: isParoleArrested,
      arrestingAgency: arrestingAgency,
      arrestDate:
        moment(arrestDate).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(arrestDate).format(formDateFormat),
      isNewsMediaCoverage: isNewsMediaCoverage,
      newsAgency: newsAgency,
      newsRepNameAndPhone: newsRepNameAndPhone,
      isLawEnforcementContacted: isLawEnforcementContacted,
      lawEnforcementAgency: lawEnforcementAgency,
      incidentDescription: incidentDescription,
      incidentCreateDate: incidentCreateDate ? incidentCreateDate : new Date(),
      incidentCreatedBy: incidentCreatedBy ? incidentCreatedBy : 17979,
    };
    if (new2284Form) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNew2284(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNew2284(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const onError = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '800px',
            maxHeight: '90vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant="h5">
                2284 Id : {defaultValue.epdIrId}
              </DialogHeading>
              <Box>
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpen2284Dialog(true);
                  }}
                >
                  Print View
                </Button>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogHeader>
            <Grid container style={{ padding: '10px 40px', marginTop: '0px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DropdownFormInput
                    name="reportingProgram"
                    control={control}
                    options={reportingPrograms}
                    defaultId={defaultValue?.reportingProgram}
                    errors={!!errors.reportingProgram}
                    helperText={errors?.reportingProgram?.message}
                    label="Reporting Program"
                    register={register('reportingProgram', {
                      onChange: (e) =>
                        dispatch(setReportingProgram(e.target.value)),
                    })}
                  />
                  <DropdownFormInput
                    name="paroleAgentOfRecord"
                    control={control}
                    options={paroleAgentOfRecords}
                    defaultId={defaultValue?.paroleAgentOfRecord}
                    label="Parole Agent Of Record"
                    register={register('paroleAgentOfRecord', {
                      onChange: (e) =>
                        dispatch(setParoleAgentOfRecord(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="incidentLocation"
                    type="text"
                    control={control}
                    errors={!!errors.incidentLocation}
                    helperText={errors?.incidentLocation?.message}
                    label="Incident Location"
                    register={register('incidentLocation', {
                      onBlur: (e) =>
                        dispatch(setIncidentLocation(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="incidentDate"
                    type="date"
                    control={control}
                    shrink={true}
                    // errors={!!errors.organizationName}
                    // helperText={errors?.organizationName?.message}
                    label="Incident Date"
                    register={register('incidentDate', {
                      onBlur: (e) =>
                        dispatch(setIncidentDate(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInputText
                    name="orgAddress"
                    type="text"
                    control={control}
                    disabled={true}
                    errors={!!errors.orgAddress}
                    helperText={errors?.orgAddress?.message}
                    label="Organization Address"
                    // register={register('orgAddress', {
                    //   onBlur: (e) => dispatch(setOrgAddress(e.target.value)),
                    // })}
                  />
                  <FormInputText
                    name="admitDate"
                    type="date"
                    control={control}
                    shrink={true}
                    // errors={!!errors.organizationName}
                    // helperText={errors?.organizationName?.message}
                    label="Admit Date"
                    register={register('admitDate', {
                      onBlur: (e) => dispatch(setAdmitDate(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="incidentAddress"
                    type="text"
                    control={control}
                    errors={!!errors.incidentAddress}
                    helperText={errors?.incidentAddress?.message}
                    label="Incident Address"
                    register={register('incidentAddress', {
                      onBlur: (e) =>
                        dispatch(setIncidentAddress(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="incidentTime"
                    type="time"
                    control={control}
                    shrink={true}
                    // errors={!!errors.organizationName}
                    // helperText={errors?.organizationName?.message}
                    label="Incident Time"
                    register={register('incidentTime', {
                      onBlur: (e) =>
                        dispatch(setIncidentTime(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="caseManagerName"
                    type="text"
                    control={control}
                    errors={!!errors.caseManagerName}
                    helperText={errors?.caseManagerName?.message}
                    label="Case Manager Name"
                    register={register('caseManagerName', {
                      onBlur: (e) =>
                        dispatch(setCaseManagerName(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="caseManagerTelephone"
                    type="text"
                    control={control}
                    errors={!!errors.caseManagerTelephone}
                    helperText={errors?.caseManagerTelephone?.message}
                    label="Case Manager Telephone"
                    register={register('caseManagerTelephone', {
                      onBlur: (e) =>
                        dispatch(setCaseManagerTelephone(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name="caseManagerEmail"
                    type="text"
                    control={control}
                    errors={!!errors.caseManagerEmail}
                    helperText={errors?.caseManagerEmail?.message}
                    label="Case Manager Email"
                    register={register('caseManagerEmail', {
                      onBlur: (e) =>
                        dispatch(setCaseManagerEmail(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">
                    Check All divisions notified :
                  </Typography>
                  <FormInputMultiCheckbox
                    name="dapo"
                    label="DAPO"
                    control={control}
                    checked={defaultValue?.dapo}
                    register={register('dapo', {
                      onChange: (e) => dispatch(setDapo(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    name="dhcs"
                    label="DHCS"
                    control={control}
                    checked={defaultValue?.dhcs}
                    register={register('dhcs', {
                      onChange: (e) => dispatch(setDhcs(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    name="drp"
                    label="DRP"
                    control={control}
                    checked={defaultValue?.drp}
                    register={register('drp', {
                      onChange: (e) => dispatch(setDrp(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    name="other"
                    label="Other"
                    control={control}
                    checked={defaultValue?.other}
                    register={register('other', {
                      onChange: (e) => dispatch(setOther(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="otherDescription"
                    type="text"
                    control={control}
                    errors={!!errors.otherDescription}
                    helperText={errors?.otherDescription?.message}
                    label="Other Description"
                    register={register('otherDescription', {
                      onBlur: (e) =>
                        dispatch(setOtherDescription(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">
                    Check other agencies contacted :
                  </Typography>
                  <FormInputMultiCheckbox
                    name="isContactedFire"
                    label="Fire"
                    control={control}
                    checked={defaultValue?.isContactedFire}
                    register={register('isContactedFire', {
                      onChange: (e) =>
                        dispatch(setIsContactedFire(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    name="isContactedParamedics"
                    label="Paramedics"
                    control={control}
                    checked={defaultValue?.isContactedParamedics}
                    register={register('isContactedParamedics', {
                      onChange: (e) =>
                        dispatch(setIsContactedParamedics(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    name="isContactedPolice"
                    label="Police"
                    control={control}
                    checked={defaultValue?.isContactedPolice}
                    register={register('isContactedPolice', {
                      onChange: (e) =>
                        dispatch(setIsContactedPolice(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="contactedAgenciesName"
                    type="text"
                    control={control}
                    errors={!!errors.contactedAgenciesName}
                    helperText={errors?.contactedAgenciesName?.message}
                    label="Name Agencies"
                    register={register('contactedAgenciesName', {
                      onBlur: (e) =>
                        dispatch(setContactedAgenciesName(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">Arrested :</Typography>
                  <FormInputMultiCheckbox
                    name="isParoleArrested"
                    label="Check if parole arrested"
                    control={control}
                    checked={defaultValue?.isParoleArrested}
                    register={register('isParoleArrested', {
                      onChange: (e) =>
                        dispatch(setIsParoleArrested(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="arrestingAgency"
                    type="text"
                    control={control}
                    errors={!!errors.arrestingAgency}
                    helperText={errors?.arrestingAgency?.message}
                    label="Name of arresting agency"
                    register={register('arrestingAgency', {
                      onBlur: (e) =>
                        dispatch(setArrestingAgency(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="arrestDate"
                    type="date"
                    control={control}
                    shrink={true}
                    // errors={!!errors.organizationName}
                    // helperText={errors?.organizationName?.message}
                    label="Aarrest Date"
                    register={register('arrestDate', {
                      onBlur: (e) => dispatch(setArrestDate(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">Media news :</Typography>
                  <FormInputMultiCheckbox
                    name="isNewsMediaCoverage"
                    label="Check if news media coverage"
                    control={control}
                    checked={defaultValue?.isNewsMediaCoverage}
                    register={register('isNewsMediaCoverage', {
                      onChange: (e) =>
                        dispatch(setIsNewsMediaCoverage(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="newsAgency"
                    type="text"
                    control={control}
                    errors={!!errors.newsAgency}
                    helperText={errors?.newsAgency?.message}
                    label="Name of news agency"
                    register={register('newsAgency', {
                      onBlur: (e) => dispatch(setNewsAgency(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name="newsRepNameAndPhone"
                    type="text"
                    control={control}
                    errors={!!errors.newsRepNameAndPhone}
                    helperText={errors?.newsRepNameAndPhone?.message}
                    label="News rep name and phone"
                    register={register('newsRepNameAndPhone', {
                      onBlur: (e) =>
                        dispatch(setNewsRepNameAndPhone(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormInputMultiCheckbox
                    name="isLawEnforcementContacted"
                    label="Check if law enforcement contacted"
                    control={control}
                    checked={defaultValue?.isLawEnforcementContacted}
                    register={register('isLawEnforcementContacted', {
                      onChange: (e) =>
                        dispatch(setIsLawEnforcementContacted(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInputText
                    name="lawEnforcementAgency"
                    type="text"
                    control={control}
                    errors={!!errors.lawEnforcementAgency}
                    helperText={errors?.lawEnforcementAgency?.message}
                    label="Name of agency contacted"
                    register={register('lawEnforcementAgency', {
                      onBlur: (e) =>
                        dispatch(setLawEnforcementAgency(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormInputText
                    name="incidentDescription"
                    type="text"
                    control={control}
                    multiline={true}
                    rows={8}
                    errors={!!errors.incidentDescription}
                    helperText={errors?.incidentDescription?.message}
                    label="Description of incident"
                    register={register('incidentDescription', {
                      onBlur: (e) =>
                        dispatch(setIncidentDescription(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              {getSaveCancel(handleClose, false, handleSubmit(onSubmit, onError))}
            </Grid>
          </>
        )}
      </Dialog>
      <Pdf2284 open={open2284Dialog} setOpen={setOpen2284Dialog} />
      {getFormSuccess(formSuccess, setFormSuccess, isNew2284)}
    </>
  );
};

export default Dialog2284;
